<template>
  <div class="newsdetails">
    <div class="box_1 flex-col">
      <div class="p_img">
        <a href="javascript:;">
          <img src="@/assets/client/banner_6.jpg" alt="新闻资讯" title="新闻资讯">
        </a>
      </div>
      <div class="p_info">
        <div>
          <h2 class="text-white p_btitle">新闻资讯</h2>
          <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
        </div>
      </div>
    </div>
    <div class="box_5 flex-col">
      <div class="box_6 flex-row">
        <div class="text-wrapper_1 flex-col justify-between">
          <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;新闻动态</span>
          <span class="text_14">{{ bigTitle }}</span>
        </div>
        <div class="text-wrapper_6_be">
          <transition  name="slide">
            <div class="text-wrapper_4 flex-col" v-if="telshow">
              <span class="text_27">4001-300-137</span>
            </div>
          </transition>
        </div>
        <div class="box_8_1">
          <div class="group_3 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <div class="image-text_1 flex-col justify-between">
              <img
                  class="label_1"
                  referrerpolicy="no-referrer"
                  :src="require('@/assets/humanResources/img/icon_lxfs.png')"
              />
              <span class="text-group_4">业务咨询</span>
            </div>
          </div>
        </div>
      </div>
      <div class="image-wrapper_1 flex-row">
        <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="@/assets/client/xwzxbg.png"
        />
      </div>
      <span class="text_20"
      >{{ about_name }}</span>
      <div class="box_8_2 flex-row justify-between">
        <div class="text-wrapper_7">
          <span class="text_21">分类：</span>
          <span class="text_22">{{ modelitemName }}</span>
          <span class="text_23">编辑：</span>
          <span class="text_22">先河环保</span>
          <span class="text_24">来源：</span>
          <span class="text_22">先河环保</span>
          <span class="text_25">发布时间：</span>
          <span class="text_22">{{ update_time }}</span>
        </div>
      </div>
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="@/assets/client/underline.png"
      />
      <div
          class="html-div"
          v-html="about_content"
      ></div>
      <div class="box_9 flex-col"></div>
      <div class="box_10 flex-row justify-between">
        <div class="text-wrapper_11">
          <div v-if="index !== 0">
            <span class="text_33">上一篇：</span>
            <span class="text_34" @click="toNews('previous')">{{ index===0?"":list[index-1].about_name }}</span>
          </div>
        </div>
        <div class="text-wrapper_12">
          <div v-if="list.length !== index + 1">
            <span class="text_36">下一篇:</span>
            <span class="text_35" @click="toNews('next')">{{ index===list.length-1?"":list[index+1].about_name }}&nbsp;</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端企业文化详情页 -->
    <div class="mobile-culture-detail">
      <!-- Banner区域 -->
      <div class="mobile-culture-detail-banner">
        <img 
          class="mobile-culture-detail-banner__image" 
          src="@/assets/aboutSailHero/img/banner_1.jpg" 
          alt="企业文化" 
        />
        <div class="mobile-culture-detail-banner__overlay"></div>
        <div class="mobile-culture-detail-banner__content">
          <h2 class="mobile-culture-detail-banner__title">{{ bigTitle }}</h2>
          <p class="mobile-culture-detail-banner__subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</p>
        </div>
      </div>

      <!-- 返回导航栏 -->
      <div class="mobile-culture-detail-navbar">
        <div class="mobile-culture-detail-navbar__back" @click="backToList">
          <span class="mobile-culture-detail-navbar__back-icon el-icon-arrow-left"></span>
          <span>返回</span>
        </div>
      </div>

      <!-- 详情内容 -->
      <div class="mobile-culture-detail-content">
        <!-- 标题和元信息 -->
        <div class="mobile-culture-detail-header">
          <h2 class="mobile-culture-detail-header__title">{{ about_name }}</h2>
          <div class="mobile-culture-detail-header__meta">
            <div class="mobile-culture-detail-header__meta-item">
              <span class="mobile-culture-detail-header__meta-label">分类：</span>
              <span class="mobile-culture-detail-header__meta-value">{{ modelitemName }}</span>
            </div>
            <div class="mobile-culture-detail-header__meta-item">
              <span class="mobile-culture-detail-header__meta-label">编辑：</span>
              <span class="mobile-culture-detail-header__meta-value">先河环保</span>
            </div>
            <div class="mobile-culture-detail-header__meta-item">
              <span class="mobile-culture-detail-header__meta-label">来源：</span>
              <span class="mobile-culture-detail-header__meta-value">先河环保</span>
            </div>
            <div class="mobile-culture-detail-header__meta-item">
              <span class="mobile-culture-detail-header__meta-label">发布时间：</span>
              <span class="mobile-culture-detail-header__meta-value">{{ update_time }}</span>
            </div>
          </div>
        </div>

        <!-- 正文 -->
        <div class="mobile-culture-detail-body">
          <div class="mobile-culture-detail-body__content" v-html="about_content"></div>
        </div>

        <!-- 上一篇/下一篇导航 -->
        <div class="mobile-culture-detail-navigation">
          <div 
            v-if="index !== 0" 
            class="mobile-culture-detail-navigation__item"
            @click="toNews('previous')"
          >
            <div class="mobile-culture-detail-navigation__label">上一篇</div>
            <div class="mobile-culture-detail-navigation__title">{{ index===0?"":list[index-1].about_name }}</div>
          </div>
          <div v-else class="mobile-culture-detail-navigation__item mobile-culture-detail-navigation__item--disabled">
            <div class="mobile-culture-detail-navigation__label">上一篇</div>
            <div class="mobile-culture-detail-navigation__empty">没有了</div>
          </div>

          <div 
            v-if="list.length !== index + 1" 
            class="mobile-culture-detail-navigation__item"
            @click="toNews('next')"
          >
            <div class="mobile-culture-detail-navigation__label">下一篇</div>
            <div class="mobile-culture-detail-navigation__title">{{ index===list.length-1?"":list[index+1].about_name }}</div>
          </div>
          <div v-else class="mobile-culture-detail-navigation__item mobile-culture-detail-navigation__item--disabled">
            <div class="mobile-culture-detail-navigation__label">下一篇</div>
            <div class="mobile-culture-detail-navigation__empty">没有了</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[],//列表
      index:0,//当前下标
      about_content: "",
      modelitemName: "",
      bigTitle: "",
      about_name: "",
      update_time: "",
      telshow:false,
      // 移动端相关数据
      isMobile: false,
    }
  },
  methods: {
    handleMouseEnter(){
      let that = this;
      that.telshow = true;
    },
    handleMouseLeave(){
      let that = this;
      that.telshow = false;
    },
    toNews(type) {
      let that = this;
      if (type === 'previous') {
        if (that.index !== 0) {
          that.about_content = that.list[that.index - 1].about_content;
          that.about_name = that.list[that.index - 1].about_name;
          that.update_time = that.list[that.index - 1].update_time;
          that.index = that.index - 1;
        }
      } else {
        if (that.index !== that.list.length - 1) {
          that.about_content = that.list[that.index + 1].about_content;
          that.about_name = that.list[that.index + 1].about_name;
          that.update_time = that.list[that.index + 1].update_time;
          that.index = that.index + 1;
        }
      }
    },
    // 移动端相关方法
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    backToList() {
      // 根据来源页面返回不同的路径
      const { bigTitle, from } = this.$route.query;
      
      // 优先使用 from 参数
      if (from === 'corporateCulture') {
        this.$router.push({
          path: "/Client/AboutSailHero/CorporateCulture"
        });
      } else if (from === 'partyBuilding') {
        this.$router.push({
          path: "/Client/AboutSailHero/PartyBuildingWork"
        });
      } 
      // 根据 bigTitle 判断
      else if (bigTitle === '企业文化') {
        this.$router.push({
          path: "/Client/AboutSailHero/CorporateCulture"
        });
      } else if (bigTitle === '党建工作') {
        this.$router.push({
          path: "/Client/AboutSailHero/PartyBuildingWork"
        });
      }
      // 默认返回党建工作页面（保持向后兼容）
      else {
        this.$router.push({
          path: "/Client/AboutSailHero/PartyBuildingWork"
        });
      }
    },
  },
  mounted() {
    let that = this;
    that.about_content = this.$route.query.about_content;
    that.modelitemName = this.$route.query.modelitem;
    that.bigTitle = this.$route.query.bigTitle;
    that.about_name = this.$route.query.about_name;
    that.update_time = this.$route.query.update_time;
    that.list = JSON.parse(this.$route.query.list);
    that.index = parseInt(this.$route.query.index);
    // 移动端检测
    that.checkMobile();
    window.addEventListener('resize', that.checkMobile);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.checkMobile);
  },
}
</script>
<style scoped>
@import '../../../../assets/aboutSailHero/css/newsdetails.css';
@import '../../../../assets/aboutSailHero/css/corporate-culture-details-mobile.css';
.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
  transform: translateX(10.53vw);
}
.p_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  animation: bannerimg 2s;
}

.p_info .p_btitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 59px;
  font-weight: 900;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p_info .p_subtitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 28px;
  font-weight: 400;
  position: relative;
  bottom: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.p_info {
  width: 100%;
  max-width: 1600px;
  padding: 0 5px;
  position: absolute;
  left: 257px;
  top: 120px;
  z-index: 9;
}

@keyframes puBanner {
  from {
    transform: translateY(200px);
    opacity: 0
  }

  to {
    transform: translateY(0);
    opacity: 1
  }
}

@keyframes bannerimg {
  from {
    transform: scale(1.15)
  }

  to {
    transform: scale(1);
  }
}
</style>
